<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/environment"
                saveRoot="/environment"
                :formStructure="dataFormStructures.environment">
        </DynamicForm>
    </div>
</template>

<script>
    import DynamicForm from '../components/DynamicForm'
    export default {
        name: 'Environment',
        components: {
            DynamicForm
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    environment: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Environnement'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'name'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'domain'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'subDomain'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'plan'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'price'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Informations de facturation'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingFirstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingLastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingEmail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingPhone'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: window.Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'subDomain',
                                type: 'text',
                                label: Core.Definition.getDefinition('Sous-domaine'),
                                value: '',
                                required:true
                            },
                            {
                                id: 'domain',
                                type: 'text',
                                label: Core.Definition.getDefinition('Domaine'),
                                value: '',
                                required:true
                            },
                            {
                                id: 'name',
                                type: 'text',
                                label: Core.Definition.getDefinition('Nom'),
                                value: '',
                                required:true
                            },
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: '',
                                onSelect: function() {}
                            },
                            {
                                id: 'plan',
                                type: 'select',
                                label: Core.Definition.getDefinition('Forfait'),
                                value: '',
                                onSelect: function() {}
                            },
                            {
                                id: 'price',
                                type: 'currency',
                                label: Core.Definition.getDefinition('Prix mensuel'),
                                value: '',
                                required:true
                            },
                            {
                                id: 'billingFirstname',
                                type: 'text',
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'billingLastname',
                                type: 'text',
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'billingEmail',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'billingPhone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label: 'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            }
                        ]
                    }
                }
            }
        },
        methods: {
        }
    }
</script>
